import UserSkill from "../user_subject";
// const { NotificationManager } = require("react-notifications");

import { axios } from "../../utils/axios";

export function remove_subject(
    user_subjects: any,
    subject_to_remove: any,
    cb: Function
) {
    console.log(subject_to_remove);
    axios()
        .delete(`/profile/subjects/${subject_to_remove.hash_key}`)
        .then((_res: any) => {
            user_subjects.delete(subject_to_remove.hash_key);
            
            // NotificationManager.success(
            //     "Click to Dismiss",
            //     `Removed subject ${subject_to_remove.title}.`,
            //     5000
            // );

            cb(user_subjects, "done");
        })
        .catch((err: any) => {
            
        // NotificationManager.warning(
        //     "Click to Dismiss",
        //     `There was a problem removing this subject.`,
        //     5000
        // );
            
            cb(undefined, "error");
        });
}
